module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "Normal ParaOverride-6"
  }, [_vm._v("To Molly, who never, ever went away. ")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-5"
  }, [_vm._v("I’m so thankful that Tanya is purely a product of my imagination. ")]), _vm._v(" "), _c('p', {
    staticClass: "heading-3 ParaOverride-8"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f86f400","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/When_You_Went_Away-3.vue
// module id = 72
// module chunks = 0